import { render, staticRenderFns } from "./my-comment.vue?vue&type=template&id=7abecfe0&scoped=true&"
import script from "./my-comment.vue?vue&type=script&lang=js&"
export * from "./my-comment.vue?vue&type=script&lang=js&"
import style0 from "./my-comment.scss?vue&type=style&index=0&id=7abecfe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abecfe0",
  null
  
)

export default component.exports